module.exports = {["template-constructor-control-picture_crop"]: function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n	<div class="icon preloader" data-alt="Crop" data-alt-pos="left" data-alt-offset="9"></div>\n\n	<div class="panel">\n		<div class="scale">\n			<div class="handler">\n				<div class="helper"></div>\n			</div>\n		</div>\n		<div class="equilateral button"></div>\n		<div class="fill button">Fill</div>\n		<div class="fit  button">Fit</div>\n		<div class="x1 button">x1</div>\n	</div>\n';
}
return __p;
},}